import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useSwitchFilters } from './hook';
import { SwitchFiltersProps } from './props';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../shared/utils/params';
import dayjs from 'dayjs';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import MultipleAutocompleteField from '../../../../components/general/fields/multipleAutocompleteField';

export const SwitchFilters = ({ onFilter, loading }: SwitchFiltersProps) => {
    const { formik, typification1, typification2, users } =
        useSwitchFilters(onFilter);
    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Cuenta"
                    name="account"
                    size="small"
                    touched={formik.touched.account}
                    errors={formik.errors.account}
                    value={formik.values.account}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={formatParams(users)}
                    name="user"
                    label="Asesor"
                    size="small"
                    touched={formik.touched.user}
                    errors={formik.errors.user}
                    value={formik.values.user}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.name
                        );
                        formik.setFieldValue('user', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typification1)}
                    label="Tipificación 1"
                    name="typification1"
                    size="small"
                    touched={formik.touched.typification1}
                    errors={formik.errors.typification1}
                    value={formik.values.typification1 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typification2)}
                    label="Tipificación 2"
                    name="typification2"
                    size="small"
                    touched={formik.touched.typification2}
                    errors={formik.errors.typification2}
                    value={formik.values.typification2 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    minDate={dayjs(formik.values.startCreatedAt)}
                    maxDate={dayjs().endOf('day')}
                    disabled={!formik.values.startCreatedAt}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
